import { Component, OnInit } from '@angular/core';
import { Field } from '../../models/field.interface';
import { FieldConfig } from '../../models/field-config.interface';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { NgClass } from '@angular/common';


@Component({
    selector: 'app-reset-button',
    templateUrl: './form-reset-button.component.html',
    styleUrls: ['./form-reset-button.component.scss'],
    imports: [ReactiveFormsModule, MatButton, NgClass]
})
export class ResetbuttonComponent  implements OnInit, Field {
  public FormControlName;
  config: FieldConfig;
  group: FormGroup;

  constructor() { }

  ngOnInit() {
    this.FormControlName = this.config.name;
  }

}
